<template>
  <el-dialog
    ref="dialog"
    v-loading="formLoading"
    :title="title"
    :visible="is_visible"
    :close-on-click-modal="false"
    width="672px"
    class="dialog meta-dialog dialog--wide publicator"
  >
    <div class="dialog__content">
      <div v-if="authField" class="auth-form">
        <h4 class="block-title fw-500">Авторизация на карьерных сайтах</h4>
        <p class="auth-form__title">
          Для публикации вакансий авторизуйтесь на карьерном сайте
        </p>

        <div v-if="!selectedPublishedVacancy">
          <div v-for="item in authElements" :key="item.id">
            <AuthorizeForm
              :field="item"
              variant="multi"
              :deleteField="true"
              :platformName="item.name"
              :options="availableOptions"
              :tabs="setAuthTabs"
              :selected-vacancy="selectedPublishedVacancy || null"
              :is-popup="true"
              @delete="deleteElement"
              @setFormLoading="value => (formLoading = value)"
            />
          </div>
        </div>
        <div v-else>
          <AuthorizeForm
            :field="editAuth"
            variant="edit"
            :platformName="selectedPublishedVacancy.work_site.value"
            :options="availableOptions"
            :tabs="setAuthTabs"
            :selected-vacancy="selectedPublishedVacancy || null"
            :is-popup="true"
            @delete="deleteElement"
            @setFormLoading="value => (formLoading = value)"
          />
        </div>
        <Button
          buttonSize="big"
          buttonColor="blue"
          buttonText="Добавить"
          hasLeftIcon
          :disabled="!availableOptions.length || !!selectedPublishedVacancy"
          iconName="Plus-bold"
          class="auth-form__add"
          @click="addAuthItem"
        />
      </div>
      <div ref="tab_panel" class="tab__panel">
        <el-tabs
          v-if="subpanels.length"
          v-model="activeSubpanel.name"
          @tab-click="tabClick($event)"
          v-loading="activeSubpanel.loading"
          class="big"
          :class="subpanels.length === 1 ? 'is-only' : ''"
        >
          <el-tab-pane
            v-for="(tab, i) in subpanels"
            :ref="tab.name"
            :key="`${i}_${tab.name}`"
            :label="workSiteLabel(tab.label)"
            :name="tab.name"
            :lazy="false"
            class="no-shadow"
          >
            <MetadataForm
              :ref="`form-${tab.name}`"
              :defParams="
                tab.name
                  ? { ...defaultParams, work_site: tab.name }
                  : defaultParams
              "
              field-size="big"
              @reset-callback="resetCallback"
              :data="selectedPublishedVacancy || null"
              @setFormLoading="
                value => {
                  (formLoading = value), (activeSubpanel.loading = value);
                }
              "
              class="publicator-form"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div slot="footer" class="footer">
      <Button
        buttonSize="big"
        buttonColor="darkBlue"
        :buttonText="publishButtonText"
        @click="(formLoading = true), submit('publish')"
        class="publish-button"
      />

      <Button
        v-if="
          activeSubpanel.name == 'career_page'
            ? !selectedPublishedVacancy ||
              (selectedPublishedVacancy &&
                selectedPublishedVacancy.status.value == 'draft')
            : true
        "
        buttonSize="big"
        buttonColor="blue"
        :buttonText="buttonText"
        @click="(formLoading = true), submit('save')"
      />
    </div>
  </el-dialog>
</template>

<script>
import { store } from '@/store';
import { Tabs, TabPane } from 'element-ui';
import { Dialog } from 'element-ui';
import MetadataForm from './MetadataForm';
import AuthorizeForm from 'Elements/AuthorizeForm/AuthorizeForm';
import { errorMsg } from '@/utils/mixins';
import { MODULE, PUBLICATOR_STATUS, FIELD } from '@/utils/constants';
import Button from 'Elements/Button/Button';
import authField from './authorise.json';

export default {
  mixins: [errorMsg],
  props: {
    is_visible: {
      type: Boolean
    },
    data: {
      type: Object,
      default: () => ({})
    },
    selectedPublishedVacancy: Object
  },
  data() {
    return {
      defaultParams: {
        module: MODULE.HRPAC_PUBLISHED_VACANCY,
        action: 'savePublishedVacancy',
        'fields[id]': '',
        jsqon_return: 1,
        to_pdf: true
      },
      formLoading: true,
      authField,
      loadedTab: [],
      subpanels: [],
      activeSubpanel: {},
      options: {},
      saving: false,
      tabsNeedScroll: false,
      enabledLeftScroll: false,
      leftScrolling: false,
      rightScrolling: false,
      enabledRightScroll: false,
      speedScroll: 150,
      minSpeedScroll: 50
    };
  },
  created() {
    setTimeout(() => {
      let tabPanel = this.$refs.tab_panel;
      const resizeObserver = new ResizeObserver(this.handleResize);
      if (tabPanel) {
        resizeObserver.observe(tabPanel);
        let tabsWrap = tabPanel.getElementsByClassName(
          'el-tabs__nav-scroll'
        )[0];
        //событие прокрутки сабпанели при помощи колёсика мыши
        tabsWrap.addEventListener('wheel', this.initMouseWheel);
      }
    }, 0);

    if (!this.authElements.length && !this.selectedPublishedVacancy) {
      const workSites = Object.values(this.workSites);
      store.commit('publicator/setAuthForm', {
        name: this.hasCareerPublishedVacancy
          ? workSites.filter(item => item != 'career_page')[0]
          : workSites[0]
      });
      store.commit('publicator/setAvailableOptions', {
        name: this.hasCareerPublishedVacancy
          ? workSites.filter(item => item != 'career_page')[0]
          : workSites[0]
      });
      this.setAuthTabs();
      store.dispatch(
        'publicator/checkAuth',
        this.hasCareerPublishedVacancy ? 'hh' : 'career_page' /* 'hh' */
      );
    } else {
      this.setAuthTabs();

      if (
        this.selectedPublishedVacancy?.edited &&
        this.selectedPublishedVacancy?.work_site.value == 'trudvsem'
      ) {
        store.dispatch('publicator/checkAuth', 'trudvsem');
      }
    }
  },
  mounted() {
    // для закрытия попапа через слушатель, не через @close
    // чтобы срабатывал лоадер при закрытии
    document.addEventListener('click', this.closeDialogByIcon);
    this.$on('hook:beforeDestroy', () =>
      document.removeEventListener('click', this.closeDialogByIcon)
    );

    if (this.selectedPublishedVacancy) {
      this.defaultParams = {
        ...this.defaultParams,
        id: this.selectedPublishedVacancy.id.value,
        'fields[id]': this.selectedPublishedVacancy.id.value
      };
    } else {
      this.$set(this.defaultParams, 'prefill[vacancy_id]', this.data.id.value);

      this.$set(
        this.defaultParams,
        'work_site',
        this.hasCareerPublishedVacancy ? 'hh' : 'career_page' /* 'hh' */
      );
    }

    this.activeSubpanel = {
      ...this.subpanels.find(
        tab =>
          tab.name == (this.hasCareerPublishedVacancy ? 'hh' : 'career_page')
      )
    };

    this.tabClick({ ...this.activeSubpanel, index: '0' });
  },
  computed: {
    editAuth() {
      const work_site = this.selectedPublishedVacancy
        ? this.selectedPublishedVacancy.work_site.value
        : '';
      const auth =
        work_site != ''
          ? this.authElements.filter(item => item.name === work_site)
          : '';

      if (auth.length) {
        if (!this.saving) this.editSubpanels(work_site);

        return auth[0];
      } else if (work_site) {
        if (!this.saving) {
          store.commit('publicator/setAuthForm', {
            name: work_site
          });
        }

        this.setAuthTabs();
        this.editSubpanels(work_site);
        store.dispatch('publicator/checkAuth', work_site);

        return this.authElements.filter(item => item.name === work_site)[0];
      } else {
        return '';
      }
    },
    availableOptions() {
      return this.hasCareerPublishedVacancy
        ? this.workSites.filter(item => item != 'career_page')
        : this.workSites;
    },
    authElements() {
      return store.state.publicator.authForm;
    },
    title: function () {
      const status = this.selectedPublishedVacancy
        ? this.selectedPublishedVacancy.status.value
        : '';

      return status == PUBLICATOR_STATUS.ARCHIVED
        ? 'Публикация вакансиии из архива'
        : status == PUBLICATOR_STATUS.DRAFT
        ? 'Публикация вакансиии из черновика'
        : status == PUBLICATOR_STATUS.DELETED
        ? 'Публикация вакансии из удаленных'
        : 'Публикация вакансии';
    },
    buttonText() {
      const status = this.selectedPublishedVacancy
        ? this.selectedPublishedVacancy.status.value
        : '';

      return status == PUBLICATOR_STATUS.ARCHIVED
        ? 'Сохранить изменения'
        : status == PUBLICATOR_STATUS.DRAFT
        ? 'Сохранить изменения'
        : status == PUBLICATOR_STATUS.DELETED
        ? 'Сохранить как черновик'
        : 'Сохранить как черновик';
    },
    publishButtonText() {
      const status = this.selectedPublishedVacancy
        ? this.selectedPublishedVacancy.status.value
        : '';

      return status == PUBLICATOR_STATUS.PUBLISHED
        ? this.selectedPublishedVacancy?.duplicate &&
          this.selectedPublishedVacancy?.work_site?.value == 'trudvsem'
          ? 'Создать публикацию'
          : 'Изменить публикацию'
        : status == PUBLICATOR_STATUS.DRAFT
        ? 'Опубликовать'
        : status == 'waiting' &&
          this.selectedPublishedVacancy?.duplicate &&
          this.selectedPublishedVacancy?.work_site?.value == 'trudvsem'
        ? 'Создать публикацию'
        : 'Опубликовать';
    },
    hasCareerPublishedVacancy() {
      return store.state.publicator.publishedVacancy.some(
        item => item.work_site.value == 'career_page'
      );
    },
    workSites() {
      return store.state.publicator.work_site_list || [];
    }
  },
  methods: {
    initMouseWheel(e) {
      const tabsWrap = this.$refs.tab_panel.getElementsByClassName(
        'el-tabs__nav-scroll'
      )[0];
      const rightScrollArea =
        this.$refs.tab_panel.getElementsByClassName('el-tabs__nav-next')[0];
      const leftScrollArea =
        this.$refs.tab_panel.getElementsByClassName('el-tabs__nav-prev')[0];
      e.preventDefault();
      e.stopPropagation();
      //если колёсико мыши прокручено вверх и зона с правой стрелкой скрыта
      //то показываем её
      if (
        leftScrollArea &&
        e.wheelDelta < 0 &&
        Array.from(leftScrollArea.classList).includes('is-disabled')
      ) {
        leftScrollArea.classList.remove('is-disabled');
      }
      //если колёсико мыши прокручено вверх и прокручено до упора
      //то скрываем зону с левой стрелкой
      else if (
        rightScrollArea &&
        e.wheelDelta < 0 &&
        (Math.floor(tabsWrap.scrollLeft + this.speedScroll * 2) + 2 >=
          tabsWrap.scrollWidth - tabsWrap.parentNode.offsetWidth ||
          Math.floor(tabsWrap.scrollLeft + this.speedScroll * 2) + 1 >=
            tabsWrap.scrollWidth - tabsWrap.parentNode.offsetWidth ||
          Math.floor(tabsWrap.scrollLeft + this.speedScroll * 2) >=
            tabsWrap.scrollWidth - tabsWrap.parentNode.offsetWidth)
      ) {
        rightScrollArea.classList.add('is-disabled');
      }
      //если колёсико мыши прокручено вниз и зона с левой кнопкой скрыта
      //то показываем её
      else if (
        rightScrollArea &&
        e.wheelDelta > 0 &&
        Array.from(rightScrollArea.classList).includes('is-disabled')
      ) {
        rightScrollArea.classList.remove('is-disabled');
      }
      //если колёсико мыши прокручено вниз и прокручено до упора
      //то скрываем зону с правой стрелкой
      else if (
        leftScrollArea &&
        e.wheelDelta > 0 &&
        tabsWrap.scrollLeft - this.speedScroll * 2 <= 0
      ) {
        leftScrollArea.classList.add('is-disabled');
      }
      tabsWrap.scrollTo({
        left:
          e.wheelDelta < 0
            ? tabsWrap.scrollLeft + this.speedScroll * 2
            : tabsWrap.scrollLeft - this.speedScroll * 2,
        behavior: 'smooth'
      });
    },
    scrollLeft() {
      let scrolling = null;
      if (this.leftScrolling) {
        let tabsWrap = this.$refs.tab_panel.getElementsByClassName(
          'el-tabs__nav-scroll'
        )[0];
        const rightScrollArea =
          this.$refs.tab_panel.getElementsByClassName('el-tabs__nav-next')[0];

        rightScrollArea.addEventListener('mousemove', e => {
          let speed = Math.abs(
            e.clientX - e.currentTarget.getBoundingClientRect().left
          );
          this.speedScroll =
            speed < this.minSpeedScroll ? this.minSpeedScroll : speed;
        });

        scrolling = setInterval(() => {
          if (
            tabsWrap.scrollLeft !== 0 &&
            Array.from(rightScrollArea.classList).includes('is-disabled')
          ) {
            rightScrollArea.classList.remove('is-disabled');
          }
          if (tabsWrap.scrollLeft !== 0 && this.leftScrolling) {
            tabsWrap.scroll({
              left: tabsWrap.scrollLeft - this.speedScroll,
              behavior: 'smooth'
            });
          } else {
            if (tabsWrap.scrollLeft === 0) {
              this.$refs.tab_panel
                .getElementsByClassName('el-tabs__nav-prev')[0]
                .classList.add('is-disabled');
            }
            clearInterval(scrolling);
          }
        }, 100);
      }
    },
    scrollRight() {
      let scrolling = null;
      if (this.rightScrolling) {
        let tabsWrap = this.$refs.tab_panel.getElementsByClassName(
          'el-tabs__nav-scroll'
        )[0];
        const leftScrollArea =
          this.$refs.tab_panel.getElementsByClassName('el-tabs__nav-prev')[0];

        leftScrollArea.addEventListener('mousemove', e => {
          const speed = Math.abs(
            e.clientX - e.currentTarget.getBoundingClientRect().right
          );
          this.speedScroll =
            speed < this.minSpeedScroll ? this.minSpeedScroll : speed;
        });
        scrolling = setInterval(() => {
          if (
            tabsWrap.scrollLeft != 0 &&
            Array.from(leftScrollArea.classList).includes('is-disabled')
          ) {
            leftScrollArea.classList.remove('is-disabled');
          }
          if (
            tabsWrap.scrollLeft != tabsWrap.scrollWidth &&
            this.rightScrolling
          ) {
            tabsWrap.scroll({
              left: tabsWrap.scrollLeft + this.speedScroll,
              behavior: 'smooth'
            });

            if (
              Math.floor(tabsWrap.scrollLeft) + 2 ===
                tabsWrap.scrollWidth - tabsWrap.parentNode.offsetWidth ||
              Math.floor(tabsWrap.scrollLeft) + 1 ===
                tabsWrap.scrollWidth - tabsWrap.parentNode.offsetWidth ||
              Math.floor(tabsWrap.scrollLeft) ===
                tabsWrap.scrollWidth - tabsWrap.parentNode.offsetWidth
            ) {
              this.$refs.tab_panel
                .getElementsByClassName('el-tabs__nav-next')[0]
                .classList.add('is-disabled');
            }
          } else {
            clearInterval(scrolling);
          }
        }, 100);
      }
    },
    handleResize() {
      setTimeout(() => {
        let tabsWrap =
          this.$refs.tab_panel?.getElementsByClassName('el-tabs__nav-wrap')[0];

        if (tabsWrap) {
          this.tabsNeedScroll = Array.from(tabsWrap?.classList).includes(
            'is-scrollable'
          );

          if (this.tabsNeedScroll) {
            //если до этого листу с табами не был нужен скролл, то надо убрать обычный функционал зон для скролла
            tabsWrap.children[0].parentNode.replaceChild(
              tabsWrap.children[0].cloneNode(true),
              tabsWrap.children[0]
            );
            tabsWrap.children[1].parentNode.replaceChild(
              tabsWrap.children[1].cloneNode(true),
              tabsWrap.children[1]
            );
            //после чего задать свой
            if (!this.enabledLeftScroll) {
              tabsWrap.children[0].addEventListener(
                'mouseover',
                () => (this.leftScrolling = true)
              );
              tabsWrap.children[0].addEventListener(
                'mouseout',
                () => (this.leftScrolling = false)
              );
            }

            if (!this.enabledRightScroll) {
              tabsWrap.children[1].addEventListener(
                'mouseover',
                () => (this.rightScrolling = true)
              );
              tabsWrap.children[1].addEventListener(
                'mouseout',
                () => (this.rightScrolling = false)
              );
            }
          }
        }
      }, 0);
    },
    closeDialogByIcon(e) {
      if (e.target.closest('.el-dialog__headerbtn')) {
        this.formLoading = true;
        setTimeout(() => this.resetCallback(), 100);

        return;
      } else return;
    },
    editSubpanels(work_site) {
      this.subpanels = this.subpanels.filter(item => item.name === work_site);
      this.activeSubpanel = this.subpanels.filter(
        item => item.name === work_site
      )[0];
    },
    workSiteLabel(label) {
      return label == 'career_page'
        ? 'Карьерная страница'
        : label == 'hh'
        ? 'HH.ru'
        : label == 'avito'
        ? 'Avito'
        : label == 'superjob'
        ? 'SuperJob'
        : label == 'trudvsem'
        ? 'ТрудВсем'
        : label == 'rabotaru'
        ? 'Работа.Ру'
        : label;
    },
    deleteElement(payload) {
      this.formLoading = true;
      store.commit('publicator/setDeleteAuthElement', {
        id: payload.id
      });
      store.commit('publicator/setAvailableOptions', { name: payload.name });
      this.setAuthTabs(payload.name);
    },
    setAuthTabs(deleteTabName, stopLoading = false) {
      this.formLoading = true;
      let result = [];
      this.authElements.map((item, idx) => {
        const newItem = {
          id: idx,
          label: item.name,
          name:
            typeof item.name == 'string' ? item.name.toLowerCase() : item.name,
          loading: false,
          lazy: false
        };

        result = [...result, { ...newItem }];
      });

      let newResult = result;

      if (this.subpanels.length > 0) {
        if (this.subpanels.length >= newResult.length) {
          for (let item in this.subpanels) {
            if (
              newResult[item] &&
              newResult[item].name !== this.subpanels[item].name
            ) {
              this.loadedTab[item] = '0';

              if (
                this.activeSubpanel.name == this.subpanels[item].name &&
                this.activeSubpanel.name != newResult[item].name
              ) {
                this.activeSubpanel = newResult[item];
                this.loadedTab[item] = newResult[item].name;
              }
            }
          }
        }

        this.subpanels = newResult;
      } else {
        this.subpanels = newResult;
        if (this.subpanels[0]) {
          this.loadedTab.push(this.subpanels[0].name);
          this.activeSubpanel = { ...this.subpanels[0] };
        }
      }

      if (this.activeSubpanel.name == deleteTabName) {
        this.activeSubpanel = { ...this.subpanels[this.subpanels.length - 1] };
      }

      if (stopLoading) this.formLoading = false;
    },
    tabClick(tab) {
      this.activeSubpanel = { ...this.subpanels[tab.index] };

      if (this.loadedTab.indexOf(this.activeSubpanel.name) >= 0) {
        this.activeSubpanel.loading = false;
      } else {
        this.loadedTab.push(this.activeSubpanel.name);
      }
    },
    submit(action) {
      this.saving = true;
      this.formLoading = true;
      const validForms = [];

      setTimeout(async () => {
        for (let index = 0; index < this.subpanels.length; index++) {
          const tab = this.subpanels[index];
          const context = this.$refs['form-' + tab.name][0];

          try {
            const result = await context.saveForm('form', tab.name);
            store.commit('publicator/setSendData', {
              workSite: tab.name,
              form: { ...context.form }
            });
            validForms.push(result);
            if (!result) {
              this.tabClick({ ...tab, index });

              // повторный скролл к полю после переключения вкладки
              this.$nextTick(() =>
                setTimeout(
                  async () => await context.saveForm('form', tab.name),
                  0
                )
              );
              this.formLoading = false;
              break;
            } else if (
              result &&
              index == this.subpanels.length - 1 &&
              validForms.length > 0 &&
              validForms.every(valid => !!valid)
            ) {
              if (this.editAuth != '' && !this.editAuth.authData.work_site) {
                setTimeout(
                  () =>
                    this.showNotification({
                      offset: 100,
                      showClose: true,
                      duration: 10000,
                      message:
                        'Для продолжения требуется авторизация на работном сайте ' +
                        this.workSiteLabel(this.editAuth.name),
                      type: 'error'
                    }),
                  500
                );

                this.formLoading = false;
                break;
              } else if (
                this.authElements.some(
                  item => !Object.keys(item.authData).length
                ) &&
                this.editAuth == ''
              ) {
                this.authElements.filter(item =>
                  !Object.keys(item.authData).length
                    ? setTimeout(
                        () =>
                          this.showNotification({
                            offset: 100,
                            showClose: true,
                            duration: 10000,
                            message:
                              'Для продолжения требуется авторизация на работном сайте ' +
                              this.workSiteLabel(item.name),
                            type: 'error'
                          }),
                        500
                      )
                    : null
                );
                this.formLoading = false;
                break;
              } else if (
                result &&
                (!this.selectedPublishedVacancy ||
                  (!!this.selectedPublishedVacancy &&
                    this.selectedPublishedVacancy.id.value &&
                    this.selectedPublishedVacancy?.status?.value !=
                      'published')) &&
                this.authElements.find(
                  item => item.name == 'rabotaru' && !item.activeBilling
                ) &&
                tab.name == 'rabotaru'
              ) {
                setTimeout(
                  () =>
                    this.showNotification({
                      offset: 100,
                      showClose: true,
                      duration: 10000,
                      message:
                        'Для продолжения требуется выбрать тарифный план на работном сайте Работа.Ру',
                      type: 'error'
                    }),
                  500
                );

                this.formLoading = false;
                break;
              }
              if (action === 'publish') {
                await this.publish();
              } else if (action === 'save') {
                await this.saveChanges();
              }

              store.commit('common/setDetachedFormFields', {
                fieldName: FIELD.ID.LANGUAGE_LEVEL,
                form: []
              });
              store.commit('common/setDetachedFormFields', {
                fieldName: FIELD.ID.ANOTHER_WORK_PLACE,
                form: []
              });
              this.saving = false;
            }
          } catch (error) {
            this.$set(validForms, tab.name, false);
            // повторный скролл к полю после переключения вкладки
            this.tabClick({ ...tab, index });
            this.$nextTick(() =>
              setTimeout(
                async () => await context.saveForm('form', tab.name),
                0
              )
            );
            validForms.push(false);
            this.formLoading = false;
            this.saving = false;
            break;
          }
        }
      }, 100);
    },
    async publish() {
      const status = this.selectedPublishedVacancy
        ? this.selectedPublishedVacancy.status.value
        : '';
      if (
        this.defaultParams['fields[id]'] &&
        status == PUBLICATOR_STATUS.DRAFT
      ) {
        this.$set(this.defaultParams, 'publish', true);
        if (this.$refs[0]) {
          this.$set(
            this.defaultParams,
            'work_site',
            this.$refs[0][0].$children[0].metaData.hidden_fields[1].value
          );
        }
      } else {
        this.$set(this.defaultParams, 'publish', true);
      }

      if (this.selectedPublishedVacancy?.duplicate) {
        this.$set(this.defaultParams, 'duplicate', true);
      }

      await store.dispatch(
        'publicator/savePublishedVacancy',
        this.defaultParams
      );

      // this.$emit('reset-callback');
      this.$emit('save-callback');
      // this.resetCallback();
    },
    async saveChanges() {
      this.$set(this.defaultParams, 'only_publish', false);
      this.$set(this.defaultParams, 'publish', false);

      if (this.selectedPublishedVacancy?.duplicate) {
        this.$set(this.defaultParams, 'duplicate', true);
      }

      await store.dispatch(
        'publicator/savePublishedVacancy',
        this.defaultParams
      );
      // this.$emit('reset-callback');
      this.$emit('save-callback');
      this.formLoading = false;
      // this.resetCallback();
    },

    addAuthItem() {
      const workSites = Object.values(this.workSites);
      store.commit('publicator/setAuthForm', {
        name: this.hasCareerPublishedVacancy
          ? workSites.filter(item => item !== 'career_page')[0]
          : workSites[0]
      });
      store.commit('publicator/setAvailableOptions', {
        name: this.hasCareerPublishedVacancy
          ? workSites.filter(item => item != 'career_page')[0]
          : workSites[0]
      });
      this.setAuthTabs();
    },
    resetCallback() {
      this.formLoading = true;
      store.commit('publicator/setSelectedPublishedVacancy', null);
      this.$emit('reset-callback');
      store.commit('common/setDetachedFormFields', {
        fieldName: FIELD.ID.LANGUAGE_LEVEL,
        form: []
      });
      store.commit('common/setDetachedFormFields', {
        fieldName: FIELD.ID.ANOTHER_WORK_PLACE,
        form: []
      });
    }
  },
  watch: {
    subpanels: {
      // вотчер для отслеживания свойства name, если оно вдруг принимает значение другой площадки (не совпадает с label)
      handler: function () {
        if (
          this.subpanels.some(
            item =>
              typeof item.name == 'string' &&
              item.name.toLowerCase() !== item.label.toLowerCase()
          )
        ) {
          this.subpanels = this.subpanels.map(item =>
            item.name !== item.label ? { ...item, name: item.label } : item
          );
        }
      },
      deep: true
    },
    leftScrolling() {
      this.scrollLeft();
    },
    rightScrolling() {
      this.scrollRight();
    }
  },
  components: {
    'el-dialog': Dialog,
    AuthorizeForm,
    MetadataForm,
    Button,
    'el-tabs': Tabs,
    'el-tab-pane': TabPane
  }
};
</script>
<style lang="scss" scoped>
.dialog {
  text-align: left;

  & ::v-deep .el-dialog {
    &__body {
      padding: 0 !important;

      .dialog__content {
        padding: 0;
      }

      .auth-form {
        background-color: $black-10;
        padding: 20px 32px 24px 32px;
        margin-bottom: 24px;

        &__title {
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
          color: $black-100;
          margin-bottom: 12px;
        }

        &__add {
          margin-top: 12px;
        }
      }

      .no-shadow {
        box-shadow: none !important;
      }

      .el-tabs {
        padding: 0;

        &__header {
          padding: 0 32px;
        }
      }

      .publicator-form {
        padding: 0;

        .buttons-panel {
          display: none;
        }

        .el-switch {
          justify-content: space-between;
        }

        .panel-row:not(.panel-row--switch) + .panel-row--switch {
          border-top: 1px solid $black-20;
          padding-top: 16px;
          margin-top: 16px;
        }

        .panel-row--switch {
          &:first-of-type {
            padding-top: 12px;
          }

          &:not(:last-child) + .panel-row--switch {
            border-top: 1px solid $black-20;
            padding-top: 16px;
          }
        }
      }

      .publicator-form,
      .auth-form {
        h4 {
          margin-top: 0;
        }

        .block-title {
          color: $grey64;
          font-weight: 500;
          font-size: 18px;
          line-height: 28px;
          text-align: left;
          margin: 0;
          margin-bottom: 12px;
          padding: 0;
        }
      }
    }
  }
}

.el-dialog__wrapper {
  .el-dialog {
    &__footer {
      .footer {
        width: unset !important;
      }
    }
  }
}

.publicator {
  height: 100%;

  .el-tab-pane {
    overflow: unset !important;
  }

  & ::v-deep .panel-row > .form-field:not(:only-child) {
    width: calc(50% - 6px);

    &:first-child {
      margin-right: 12px;
    }

    .dropdown-el .el-select__tags > span .el-tag .el-select__tags-text {
      max-width: 80px !important;
    }
  }
}
</style>
